// const baseApiurl = `https://humansyncdemo-axe7a7dzdtbgf0gm.+centralus-01.azurewebsites.net/api/`;
// const baseApiurl = `https://ara-payroll-cyezfwb6d9g0h8ew.centralus-01.azurewebsites.net/api/`; /* Live */
const baseApiurl = `https://ayyanfabshrms-exatfadxbgd2fjfp.centralus-01.azurewebsites.net/api/`;

// const CHAT_LIVE_URL = 'https://arahumansyncchat-g2hgefc2bba7d9g2.centralindia-01.azurewebsites.net';
const CHAT_LIVE_URL = 'https://ayyanfabshrms-exatfadxbgd2fjfp.centralus-01.azurewebsites.net/api/';

// UAT: chat is baked into the same WebApi host as baseApiurl. Live: chat is a
// separate standalone service at CHAT_LIVE_URL. There's no build-time env flag
// in this app yet, so we infer the environment from baseApiurl's own host —
// if/when a real UAT/Live build switch is introduced, wire chatBaseUrl off
// that flag instead (see group-chat-integration.md §0).
const chatBaseUrl = baseApiurl.includes('humansyncdemo')
    ? baseApiurl.replace(/\/api\/?$/, '')
    : CHAT_LIVE_URL.replace(/\/api\/?$/, '');

const Chat = `${chatBaseUrl}/api/Chat/`;
const GroupChatSettings = `${chatBaseUrl}/api/GroupChatSettings/`;
export const ChatHubUrl = `${chatBaseUrl}/hubs/chat`;

const Auth = `${baseApiurl}Auth/`;
const Setup = `${baseApiurl}Setup/`;
const Dashboard = `${baseApiurl}Dashboard/`;
const UserType = `${baseApiurl}UserType/`;
const FinancialYear = `${baseApiurl}FinancialYear/`;
const Access = `${baseApiurl}Access/`;
const ExcelImport = `${baseApiurl}ExcelImport/`;
const Employee = `${baseApiurl}Employee/`;
const LoginIdFormat = `${baseApiurl}LoginIdFormat/`;
const LeavePolicy = `${baseApiurl}LeavePolicy/`;
const EmployeeAttendance = `${baseApiurl}EmployeeAttendance/`;
const ShiftAssignment = `${baseApiurl}ShiftAssignment/`;
const Overtime = `${baseApiurl}Overtime/`;
const SalaryAdvance = `${baseApiurl}SalaryAdvance/`;
const EmployeeDocument = `${baseApiurl}EmployeeDocument/`;
const Department = `${baseApiurl}Department/`;
const Designation = `${baseApiurl}Designation/`;
const Recruitment = `${baseApiurl}Recruitment/`;
const Inbox = `${baseApiurl}Inbox/`;
const BusinessEntity = `${baseApiurl}BusinessEntity/`;
const DocumentManagement = `${baseApiurl}DocumentManagement/`;
const OrganisationDocuments = `${baseApiurl}OrganisationDocuments/`;
const ClientLocation = `${baseApiurl}ClientLocation/`;
const Resignation = `${baseApiurl}Resignation/`;
const PunchRequest = `${baseApiurl}PunchRequest/`;
const SelfAttendance = `${baseApiurl}SelfAttendance/`;
const LocationTracking = `${baseApiurl}LocationTracking/`;
const SitePunch = `${baseApiurl}SitePunch/`;
const payRoll = `${baseApiurl}payRoll/`;
const payrollCycle = `${baseApiurl}PayrollCycle/`;
const leavePolicy = `${baseApiurl}leavePolicy/`;
const leave = `${baseApiurl}leave/`;
const biometrics = `${baseApiurl}biometrics/`;
const staffManagement = `${baseApiurl}staffManagement/`;

export const PostLogin = `${Auth}PostLogin`;
export const PostRefreshToken = `${Auth}PostRefreshToken`;
export const PostLogout = `${Auth}PostLogout`;
export const PostChangePassword = `${Auth}PostChangePassword`;
export const PostChangeEmail = `${Auth}PostChangeEmail`;
export const PostUpdateProfile = `${Auth}PostUpdateProfile`;

export const GetEntitySetupStatus = `${Setup}GetEntitySetupStatus`;

export const GetDashboard = `${Dashboard}GetDashboard`;
export const GetMasterDashboard = `${Dashboard}GetMasterDashboard`;
export const GetActionRequired = `${Dashboard}GetActionRequired`;
export const GetMyDashboard = `${Dashboard}GetMyDashboard`;

export const GetUserTypes = `${UserType}GetUserTypes`;
export const PostUserType = `${UserType}PostUserType`;
export const UpdateUserType = `${UserType}UpdateUserType`;
export const DeleteUserType = `${UserType}DeleteUserType`;
export const GetUsersByUserType = `${UserType}GetUsersByUserType`;

export const GetModules = `${Access}GetModules`;
export const GetRoleAccess = `${Access}GetRoleAccess`;
export const UpdateRoleAccess = `${Access}UpdateRoleAccess`;

export const GetFinancialYearConfig = `${FinancialYear}GetFinancialYearConfig`;
export const PostFinancialYearConfig = `${FinancialYear}PostFinancialYearConfig`;

export const GetImportTemplate = `${ExcelImport}GetImportTemplate`;
export const ValidateImport = `${ExcelImport}ValidateImport`;
export const ImportEmployees = `${ExcelImport}ImportEmployees`;

export const GetEmployees = `${Employee}GetEmployees`;
export const GetEmployeeById = `${Employee}GetEmployeeById`;
export const PostEmployee = `${Employee}PostEmployee`;
export const UpdateEmployee = `${Employee}UpdateEmployee`;
export const InactivateEmployee = `${Employee}InactivateEmployee`;
export const SetEmployeeLoginPassword = `${Employee}SetEmployeeLoginPassword`;
export const BulkCreateEmployeeLogins = `${Employee}BulkCreateEmployeeLogins`;
export const UpdateEmployeeUserType = `${Employee}UpdateEmployeeUserType`;
export const GetEmployeeCredentials = `${Employee}GetEmployeeCredentials`;

export const GetLoginIdFormat = `${LoginIdFormat}GetLoginIdFormat`;
export const UpdateLoginIdFormat = `${LoginIdFormat}UpdateLoginIdFormat`;

export const PostLeavePolicy = `${LeavePolicy}PostLeavePolicy`;
export const GetLeavePolicyByFinancialYear = `${LeavePolicy}GetLeavePolicy`;
export const PostLeaveType = `${LeavePolicy}PostLeaveType`;
export const GetLeaveTypes = `${LeavePolicy}GetLeaveTypes`;
export const GetLeaveTypeByID = `${LeavePolicy}GetLeaveTypeByID`;
export const UpdateLeaveTypeByID = `${LeavePolicy}UpdateLeaveTypeByID`;
export const DeleteLeaveTypeByID = `${LeavePolicy}DeleteLeaveTypeByID`;
export const PostWorkingCalendar = `${LeavePolicy}PostWorkingCalendar`;
export const GetWorkingCalendar = `${LeavePolicy}GetWorkingCalendar`;
export const GetEmployeeLeaveBalance = `${LeavePolicy}GetEmployeeLeaveBalance`;

export const GetEmployeeAttendance = `${EmployeeAttendance}GetEmployeeAttendance`;
export const PostEmployeeManualAttendance = `${EmployeeAttendance}PostEmployeeManualAttendance`;
export const GetEmployeeAttendanceAudit = `${EmployeeAttendance}GetEmployeeAttendanceAudit`;
export const GetEmployeeAttendanceOverview = `${EmployeeAttendance}GetEmployeeAttendanceOverview`;
export const GetAttendanceEmployeeBefore = `${EmployeeAttendance}GetAttendanceEmployeeBefore`;

export const GetUnassignedEmployees = `${ShiftAssignment}GetUnassignedEmployees`;
export const GetShiftAssignedEmployees = `${ShiftAssignment}GetShiftAssignedEmployees`;
export const AssignEmployeeToShift = `${ShiftAssignment}AssignEmployeeToShift`;
export const UpdateAssignedEmployee = `${ShiftAssignment}UpdateAssignedEmployee`;
export const UnassignEmployee = `${ShiftAssignment}UnassignEmployee`;

export const getPayrollCycle = `${payrollCycle}GetCycle`;
export const getPayrollRegister = `${payrollCycle}GetRegister`;
export const getPayrollPayslip = `${payrollCycle}GetPayslip`;
// The payslip document itself (earnings, deductions and the rule breakdown),
// as opposed to payRoll/GetMyPayslip which returns the request rows.
export const GetMyPayslipDocument = `${payrollCycle}GetMyPayslip`;
export const postLockAttendancePayrollCycle = `${payrollCycle}PostLockAttendance`;
export const postCalculatePayrollCycle = `${payrollCycle}PostCalculate`;
export const postApprovePayrollCycle = `${payrollCycle}PostApprove`;
export const postMarkCreditedPayrollCycle = `${payrollCycle}PostMarkCredited`;
export const postRollbackPayrollCycle = `${payrollCycle}PostRollback`;
export const getPayrollInputs = `${payrollCycle}GetInputs`;
export const putPayrollInputs = `${payrollCycle}PutInputs`;

export const getEmployees = `${payRoll}GetEmployees`;
export const getEmployeesWithoutSalaryStructure = `${payRoll}GetEmployeesWithoutSalaryStructure`;
export const postSalaryStructure = `${payRoll}PostSalaryStructure`;
export const updateSalaryStructureByEmployeeCode = `${payRoll}UpdateSalaryStructureByEmployeeCode`;
export const updateSalaryStructureByRollnumber = `${payRoll}updateSalaryStructureByRollnumber`;
export const deleteSalaryStructureByEmployeeCode = `${payRoll}DeleteSalaryStructureByEmployeeCode`;
export const getSalaryComponentConfig = `${payRoll}GetSalaryComponentConfig`;
export const postSalaryComponentConfig = `${payRoll}PostSalaryComponentConfig`;
export const deleteSalaryStructureByRollnumber = `${payRoll}deleteSalaryStructureByRollnumber`;
export const salaryStructureDashboard = `${payRoll}GetSalaryStructureDashboard`;

export const postPFConfiguration = `${payRoll}PostPFConfiguration`;
export const postESIConfiguration = `${payRoll}PostESIConfiguration`;
export const postProfessionalTaxConfiguration = `${payRoll}PostProfessionalTaxConfiguration`;
export const postTDSConfiguration = `${payRoll}PostTDSConfiguration`;
export const getDeductionsAndCompliance = `${payRoll}GetDeductionsAndCompliance`;
export const employeeComplianceDashboard = `${payRoll}GetEmployeeComplianceDashboard`;
export const updateEmployeeComplianceByEmployeeCode = `${payRoll}UpdateEmployeeComplianceByEmployeeCode`;
export const updateEmployeeComplianceByRollnumber = `${payRoll}updateEmployeeComplianceByRollnumber`;

export const GetEmployeesMissingBankDetails = `${payRoll}GetEmployeesMissingBankDetails`;

export const approvePayrollPayslipsDashboard = `${payRoll}GetApprovePayrollPayslipsDashboard`;
export const getPayrollPayslipByRollNumber = `${payRoll}getPayrollPayslipByRollNumber`;

export const RequestPayslip = `${payRoll}RequestPayslip`;
export const GetMyPayslipRequests = `${payRoll}GetMyPayslipRequests`;
export const GetMyPayslip = `${payRoll}GetMyPayslip`;
export const GetPayslipRequests = `${payRoll}GetPayslipRequests`;
export const UpdatePayslipRequestAction = `${payRoll}UpdatePayslipRequestAction`;
export const ApproveAllPayslipRequests = `${payRoll}ApproveAllPayslipRequests`;

export const leavePolicyDashboard = `${payRoll}leavePolicyDashboard`;
export const postLeaveType = `${payRoll}postLeaveType`;
export const updateLeaveTypeById = `${payRoll}updateLeaveTypeById`;

export const GetSalaryAdvancesDashboard = `${SalaryAdvance}GetSalaryAdvancesDashboard`;
export const UpdateAdvanceRequestAction = `${SalaryAdvance}UpdateAdvanceRequestAction`;
export const GetAdvanceFormOptions = `${SalaryAdvance}GetAdvanceFormOptions`;
export const RequestAdvance = `${SalaryAdvance}RequestAdvance`;
export const GetMyAdvanceRequests = `${SalaryAdvance}GetMyAdvanceRequests`;

export const GetOvertimeDashboard = `${Overtime}GetOvertimeDashboard`;
export const AddOvertimeRateSlab = `${Overtime}AddOvertimeRateSlab`;
export const UpdateOvertimeRateSlab = `${Overtime}UpdateOvertimeRateSlab`;
export const DeleteOvertimeRateSlab = `${Overtime}DeleteOvertimeRateSlab`;
export const UpdateOvertimeCountsAfter = `${Overtime}UpdateOvertimeCountsAfter`;
export const UpdateSundayOvertime = `${Overtime}UpdateSundayOvertime`;
export const UpdateOvertimeEntryAction = `${Overtime}UpdateOvertimeEntryAction`;
export const RequestOvertime = `${Overtime}RequestOvertime`;
export const GetMyOvertimeRequests = `${Overtime}GetMyOvertimeRequests`;

export const postLeaveRequest = `${leave}PostLeaveRequest`;
export const getLeaveApprovalDashboard = `${leave}GetLeaveApprovalDashboard`;
export const GetLeaveApprovalStatusCheck = `${leave}GetLeaveApprovalStatusCheck`;
export const updateLeaveApprovalAction = `${leave}UpdateLeaveApprovalAction`;
export const leaveApprovalStatusCheck = `${baseApiurl}leaveApprovalStatusCheck`;
export const GetMyRequests = `${baseApiurl}MyRequests/GetMyRequests`;

export const postleavepolicy = `${leavePolicy}postleavepolicy`;
export const GetLeavePolicy = `${leavePolicy}GetLeavePolicy`;
export const postleavetypes = `${leavePolicy}postleavetypes`;
export const GetleaveTypes = `${leavePolicy}GetleaveTypes`;
export const postworkingcalendar = `${leavePolicy}postworkingcalendar`;
export const GetWorkingcalendar = `${leavePolicy}GetWorkingcalendar`;
export const UpdateleaveTypeByID = `${leavePolicy}UpdateleaveTypeByID`;
export const DeleteleaveTypeByID = `${leavePolicy}DeleteleaveTypeByID`;

export const reportsLeaveManagement = `${baseApiurl}Reports/GetReportsLeaveManagement`;
export const reportsLeaveManagementFullReport = `${baseApiurl}Reports/GetReportsLeaveManagementFullReport`;

export const getStaffAttendanceOverview = `${baseApiurl}teachersattendance/getStaffAttendanceOverview`;
export const GetAttendanceTeacherBefore = `${baseApiurl}teachersattendance/GetAttendanceTeacherBefore`;
export const GetTeachersAttendance = `${baseApiurl}teachersattendance/GetTeachersAttendance`;
export const PostTeachersManualAttendance = `${baseApiurl}teachersattendance/PostTeachersManualAttendance`;

export const SyncStatus = `${biometrics}SyncStatus/`;
export const TriggerManualSync = `${biometrics}TriggerManualSync/`;
export const GetBiometricMappings = `${biometrics}GetBiometricMappings/`;
export const PostBiometricMappings = `${biometrics}PostBiometricMappings/`;
export const UpdateBiometricMappings = `${biometrics}UpdateBiometricMappings/`;

export const GetStaffInformation = `${staffManagement}GetStaffInformation`;

export const UploadEmployeeDoc = `${EmployeeDocument}PostEmployeeDocument`;
export const GetEmployeeDocs = `${EmployeeDocument}GetEmployeeDocuments`;
export const DownloadEmployeeDoc = `${EmployeeDocument}DownloadEmployeeDocument`;
export const DeleteEmployeeDoc = `${EmployeeDocument}DeleteEmployeeDocument`;

export const GetDepartments = `${Department}GetDepartments`;
export const CreateDepartment = `${Department}CreateDepartment`;
export const UpdateDepartment = `${Department}UpdateDepartment`;
export const DeleteDepartment = `${Department}DeleteDepartment`;

export const GetDesignations = `${Designation}GetDesignations`;
export const CreateDesignation = `${Designation}CreateDesignation`;
export const UpdateDesignation = `${Designation}UpdateDesignation`;
export const DeleteDesignation = `${Designation}DeleteDesignation`;

export const GetVacancies = `${Recruitment}GetVacancies`;
export const CreateVacancy = `${Recruitment}CreateVacancy`;
export const UpdateVacancy = `${Recruitment}UpdateVacancy`;
export const SetVacancyStatus = `${Recruitment}SetVacancyStatus`;
export const DeleteVacancy = `${Recruitment}DeleteVacancy`;

export const GetCandidates = `${Recruitment}GetCandidates`;
export const AddCandidate = `${Recruitment}AddCandidate`;
export const UpdateCandidate = `${Recruitment}UpdateCandidate`;
export const SetCandidateStage = `${Recruitment}SetCandidateStage`;
export const DeleteCandidate = `${Recruitment}DeleteCandidate`;

export const GetInterviews = `${Recruitment}GetInterviews`;
export const GetInterviewFormOptions = `${Recruitment}GetInterviewFormOptions`;
export const ScheduleInterview = `${Recruitment}ScheduleInterview`;
export const UpdateInterview = `${Recruitment}UpdateInterview`;
export const RescheduleInterview = `${Recruitment}RescheduleInterview`;
export const MarkInterviewConducted = `${Recruitment}MarkInterviewConducted`;
export const MarkInterviewNoShow = `${Recruitment}MarkInterviewNoShow`;
export const ReviewInterview = `${Recruitment}ReviewInterview`;
export const CancelInterview = `${Recruitment}CancelInterview`;

export const GetInterviewFieldDefinitions = `${Recruitment}GetInterviewFieldDefinitions`;
export const CreateInterviewFieldDefinition = `${Recruitment}CreateInterviewFieldDefinition`;
export const UpdateInterviewFieldDefinition = `${Recruitment}UpdateInterviewFieldDefinition`;
export const DeleteInterviewFieldDefinition = `${Recruitment}DeleteInterviewFieldDefinition`;
export const UploadInterviewFieldFile = `${Recruitment}UploadInterviewFieldFile`;

export const AddCandidateCommunication = `${Recruitment}AddCandidateCommunication`;
export const UpdateCandidateCommunication = `${Recruitment}UpdateCandidateCommunication`;
export const DeleteCandidateCommunication = `${Recruitment}DeleteCandidateCommunication`;
export const GetCandidateCommunications = `${Recruitment}GetCandidateCommunications`;

export const GetAuditLog = `${Recruitment}GetAuditLog`;

export const GetInbox = `${Inbox}GetInbox`;
export const UpdateMessageReadStatus = `${Inbox}UpdateMessageReadStatus`;
export const MarkAllRead = `${Inbox}MarkAllRead`;
export const DeleteMessage = `${Inbox}DeleteMessage`;
export const ClearAll = `${Inbox}ClearAll`;

export const GetBusinessEntitiesDashboard = `${BusinessEntity}GetBusinessEntitiesDashboard`;
export const GetBusinessEntityById = `${BusinessEntity}GetBusinessEntityById`;
export const PostBusinessEntity = `${BusinessEntity}PostBusinessEntity`;
export const UpdateBusinessEntityById = `${BusinessEntity}UpdateBusinessEntityById`;
export const DeleteBusinessEntityById = `${BusinessEntity}DeleteBusinessEntityById`;
export const UploadBusinessEntityLogo = `${BusinessEntity}UploadBusinessEntityLogo`;
export const RemoveBusinessEntityLogo = `${BusinessEntity}RemoveBusinessEntityLogo`;

export const GetDocumentRequests = `${DocumentManagement}GetDocumentRequests`;
export const PostDocumentRequest = `${DocumentManagement}PostDocumentRequest`;
export const PostAddRecipients = `${DocumentManagement}PostAddRecipients`;
export const DeleteDocumentRequest = `${DocumentManagement}DeleteDocumentRequest`;
export const GetPendingApprovals = `${DocumentManagement}GetPendingApprovals`;
export const UpdateApprovalAction = `${DocumentManagement}UpdateApprovalAction`;
export const PostApproveAll = `${DocumentManagement}PostApproveAll`;
export const DownloadSubmission = `${DocumentManagement}DownloadSubmission`;
export const GetEmployeeDocuments = `${DocumentManagement}GetEmployeeDocuments`;
export const DownloadEmployeeDocument = `${DocumentManagement}DownloadEmployeeDocument`;
export const DeleteEmployeeDocument = `${DocumentManagement}DeleteEmployeeDocument`;
export const GetMyDocumentRequests = `${DocumentManagement}GetMyDocumentRequests`;
export const PostMyDocumentUpload = `${DocumentManagement}PostMyDocumentUpload`;

export const GetOrganisationDocuments = `${OrganisationDocuments}GetOrganisationDocuments`;
export const GetMyOrganisationDocuments = `${OrganisationDocuments}GetMyOrganisationDocuments`;
export const PostOrganisationDocument = `${OrganisationDocuments}PostOrganisationDocument`;
export const UpdateOrganisationDocument = `${OrganisationDocuments}UpdateOrganisationDocument`;
export const DeleteOrganisationDocument = `${OrganisationDocuments}DeleteOrganisationDocument`;
export const DownloadOrganisationDocument = `${OrganisationDocuments}DownloadOrganisationDocument`;

export const GetClientLocations = `${ClientLocation}GetClientLocations`;
export const GetClientLocationById = `${ClientLocation}GetClientLocationById`;
export const CreateClientLocation = `${ClientLocation}CreateClientLocation`;
export const UpdateClientLocation = `${ClientLocation}UpdateClientLocation`;
export const DeleteClientLocation = `${ClientLocation}DeleteClientLocation`;
export const GetLocationAssignments = `${ClientLocation}GetLocationAssignments`;
export const AssignLocation = `${ClientLocation}AssignLocation`;
export const UpdateLocationAssignment = `${ClientLocation}UpdateLocationAssignment`;
export const DeleteLocationAssignment = `${ClientLocation}DeleteLocationAssignment`;
export const GetMyAssignedLocations = `${ClientLocation}GetMyAssignedLocations`;

export const GetResignations = `${Resignation}GetResignations`;
export const SubmitResignation = `${Resignation}SubmitResignation`;
export const UpdateResignation = `${Resignation}UpdateResignation`;
export const SetResignationStatus = `${Resignation}SetResignationStatus`;
export const DeleteResignation = `${Resignation}DeleteResignation`;
export const GetMyResignation = `${Resignation}GetMyResignation`;
export const WithdrawResignation = `${Resignation}WithdrawResignation`;
export const GetFinalSettlement = `${Resignation}GetFinalSettlement`;
export const GetEmployeeFinalSettlement = `${Resignation}GetEmployeeFinalSettlement`;
export const GetResignationSetting = `${Resignation}GetResignationSetting`;
export const SaveResignationSetting = `${Resignation}SaveResignationSetting`;

export const GetMissedPunches = `${PunchRequest}GetMissedPunches`;
export const PostPunchRequest = `${PunchRequest}PostPunchRequest`;
export const GetMyPunchRequests = `${PunchRequest}GetMyPunchRequests`;
export const GetPunchRequests = `${PunchRequest}GetPunchRequests`;
export const ApprovePunchRequest = `${PunchRequest}ApprovePunchRequest`;
export const RejectPunchRequest = `${PunchRequest}RejectPunchRequest`;

export const GetSelfPunchSummary = `${SelfAttendance}GetSelfPunchSummary`;
export const GetSelfPunches = `${SelfAttendance}GetSelfPunches`;
export const GetSelfPunchDetail = `${SelfAttendance}GetSelfPunchDetail`;
export const GetEmployeesWithoutCheckIn = `${SelfAttendance}GetEmployeesWithoutCheckIn`;
export const DownloadSelfPunchPhoto = `${SelfAttendance}DownloadPunchPhoto`;

export const GetLocationTrips =`${LocationTracking}GetLocationTrips`;
export const GetTripRoute = `${LocationTracking}GetTripRoute`;

export const GetSitePunches = `${SitePunch}GetSitePunches`;
export const GetMySitePunches = `${SitePunch}GetMySitePunches`;
export const DownloadPunchPhoto = `${SitePunch}DownloadPunchPhoto`;

// ---- Group Chat (see group-chat-integration.md) ----
// Groups
export const GetGroups = `${Chat}GetGroups`;
export const GetGroupInfo = `${Chat}GetGroupInfo`;
export const CreateGroup = `${Chat}CreateGroup`;
export const UpdateGroup = `${Chat}UpdateGroup`;
export const UpdateGroupMembers = `${Chat}UpdateGroupMembers`;
export const MuteGroup = `${Chat}MuteGroup`;
export const SearchUsers = `${Chat}SearchUsers`;
export const GetChatUsers = `${Chat}GetChatUsers`;
export const UpdateMemberRole = `${Chat}UpdateMemberRole`;
export const LeaveGroup = `${Chat}LeaveGroup`;
export const DeleteGroup = `${Chat}DeleteGroup`;
// Messages
export const SendMessage = `${Chat}SendMessage`;
export const FetchMessages = `${Chat}FetchMessages`;
// Named DeleteChatMessage (not DeleteMessage) to avoid colliding with the
// existing Inbox DeleteMessage export above.
export const DeleteChatMessage = `${Chat}DeleteMessage`;
export const EditMessage = `${Chat}EditMessage`;
export const ReactMessage = `${Chat}ReactMessage`;
export const PinMessage = `${Chat}PinMessage`;
export const MarkRead = `${Chat}MarkRead`;
export const ClearChat = `${Chat}ClearChat`;
export const FetchMedia = `${Chat}FetchMedia`;
export const SearchMessages = `${Chat}SearchMessages`;
export const GetMessageReadInfo = `${Chat}GetMessageReadInfo`;
// Group-create permission (MasterAdmin only to manage; read-only consumed here)
export const GetCreatePermissions = `${GroupChatSettings}GetCreatePermissions`;
export const SetCreatePermission = `${GroupChatSettings}SetCreatePermission`;
